// extracted by mini-css-extract-plugin
var _1 = "TPHSN9FSwkTnGYrp20WM";
var _2 = "YcL4aqxYC1kvbVYKD5no";
export { _1 as "masonry", _2 as "solo" }
